import { render, staticRenderFns } from "./allInfo.vue?vue&type=template&id=1795fc9a&scoped=true&"
import script from "./allInfo.vue?vue&type=script&lang=js&"
export * from "./allInfo.vue?vue&type=script&lang=js&"
import style0 from "./allInfo.vue?vue&type=style&index=0&id=1795fc9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795fc9a",
  null
  
)

export default component.exports